module.exports = __webpack_public_path__ + "static/img/logo_white.0a65076a.png";